import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismIconBrand } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { and, eq } from 'ember-truth-helpers';

interface GeneralTooltipsTooltipRatesBodySectionSignature {
  Args: {
    compRatesArray: unknown;
    competitorRatesWithDifferentLos?: {
      [los: string]: unknown;
    };
    isLastSection?: boolean;
    otaId: unknown;
    shortTermRentalRate: unknown;
  };
}

const GeneralTooltipsTooltipRatesBodySection = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if @compRatesArray}}
    <div
      class="tooltip-section text-200--regular
        {{if @isLastSection 'tooltip-section--no-border'}}"
    >
      <table cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th class="hotel-name">
              {{t "general.property.plural" count=1}}
            </th>
            <th class="competitor-rate">
              {{t "rates.rate"}}
            </th>
            <th class="rate-icons"></th>
            <th class="rates-tooltip-roomname">
              {{#if (eq @otaId "allchannels")}}
                {{t "rates.cheapest_channels"}}
              {{/if}}
            </th>
          </tr>
        </thead>
        <tbody class="tooltip-competitors text-200--regular">
          {{#each @compRatesArray as |competitorRate|}}
            <tr
              class="{{if competitorRate.isOwnHotel 'highlight'}}
                {{if competitorRate.isHoveredHotel 'hovered'}}"
            >
              <td class="hotel-name">
                <div class="flex flex-row items-center">
                  {{#if competitorRate.backgroundColor}}
                    <div
                      class="identifier-bullet"
                      style={{competitorRate.backgroundColor}}
                    ></div>
                  {{/if}}
                  <p class="text-200--regular">{{competitorRate.hotel.name}}</p>
                </div>
              </td>
              <td
                class="competitor-rate"
                data-test-id="tooltip-marketrates-rate"
              >
                <div class="flex justify-start">
                  {{competitorRate.rate}}
                  {{#if
                    (and
                      competitorRate.hasLosRestriction
                      @competitorRatesWithDifferentLos.loading
                    )
                  }}
                    <p class="loading-state-other-los-rate"></p>
                  {{/if}}
                </div>
              </td>
              <td class="rate-icons">
                <div class="flex h-full items-center gap-100">
                  {{#each competitorRate.rateIcons as |rateIcon|}}
                    {{#if rateIcon}}
                      <PrismIcon @name={{rateIcon}} @size="extra-small" />
                    {{/if}}
                  {{/each}}
                </div>
              </td>
              {{#if competitorRate.allChannelsOtas}}
                <td class="favicons">
                  <div class="flex h-full items-center gap-100">
                    {{#each competitorRate.allChannelsOtas as |otaObj|}}
                      <PrismIconBrand @name={{otaObj.ota}} />
                    {{/each}}
                  </div>
                </td>
              {{else}}
                <td class="rates-tooltip-roomname">
                  {{#if
                    (and
                      competitorRate.hasLosRestriction
                      @competitorRatesWithDifferentLos.loading
                    )
                  }}
                    <p class="loading-state-other-los-rate"></p>
                  {{else}}
                    {{competitorRate.roomName}}
                  {{/if}}
                </td>
              {{/if}}
            </tr>
          {{/each}}
          {{#if @shortTermRentalRate}}
            <tr class="short-term-rental-row">
              <td class="hotel-name">
                <div class="flex flex-row items-center">
                  {{#if @shortTermRentalRate.showIdentifierBullet}}
                    <div
                      class="identifier-bullet"
                      style={{@shortTermRentalRate.backgroundColor}}
                    ></div>
                  {{/if}}
                  <p class="text-200--regular">{{@shortTermRentalRate.name}}</p>
                </div>
              </td>
              <td class="competitor-rate" colspan="3">
                <div
                  class="flex justify-start"
                >{{@shortTermRentalRate.rate}}</div>
              </td>
            </tr>
          {{/if}}
        </tbody>
      </table>
    </div>
    {{#if @shortTermRentalRate}}
      <p class="short-term-rental-message text-200--regular">
        {{t
          "short_term_rental.tooltip.number_of_rental.count"
          count=@shortTermRentalRate.numberOfProperties
        }}
      </p>
    {{/if}}
  {{/if}}
</template> satisfies TOC<GeneralTooltipsTooltipRatesBodySectionSignature>;

export default GeneralTooltipsTooltipRatesBodySection;
